import React from "react";
import { string, oneOfType, objectOf, number } from "prop-types";

const CheckCircle = ({ style, className }) => (
	<i
		style={{
			...style,
			display: "inline-block",
			fill: "currentColor",
		}}
		className={className}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{
				width: "100%",
				height: "100%",
			}}
			viewBox="0 0 34 34">
			<g fill="#fff" style={{ stroke: "currentcolor" }} strokeWidth="1.5">
				<circle cx="17" cy="17" r="17" stroke="none" />
				<circle cx="17" cy="17" r="16.25" fill="none" />
			</g>
			<path
				d="M-3466.848-14660.321l5.578,5.578,9.112-9.112"
				transform="translate(3477 14676)"
				fill="none"
				style={{ stroke: "currentcolor" }}
				strokeLinecap="round"
				strokeWidth="1.5"
			/>
		</svg>
	</i>
);

CheckCircle.propTypes = {
	className: string,
	style: objectOf(oneOfType([string, number])),
};
CheckCircle.defaultProps = {
	className: "",
	style: {},
};

export default CheckCircle;
export { CheckCircle };
